'use client';

import type { FC } from 'react';

import { isNullOrEmpty } from '@/utils/null-utils';

import { FragmentParser } from '../../utility/FragmentParser';

import S from './styles.module.scss';

export interface IAboveATCDetailsProps {
  /** The product details string to display above the cart button. */
  aboveCartDetails: string | null;
}

/** Component that displays product details above the Add to Cart button. */
export const AboveATCDetails: FC<IAboveATCDetailsProps> = ({
  aboveCartDetails
}) => {
  if (isNullOrEmpty(aboveCartDetails)) {
    return null;
  }

  return (
    <div className={S.content}>
      <FragmentParser string={aboveCartDetails} />
    </div>
  );
};
